// LoadingAnimation.js
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const LoadingAnimation = ({ animationData, animationDataMobile }) => {
  const lottieRef = useRef(null);
  const lottieRefMobile = useRef(null);

  useEffect(() => {
    if (window.innerWidth >= 1024) { // Assuming lg starts at 1024px
      const animationInstance = lottie.loadAnimation({
        container: lottieRef.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animationData,
      });

      return () => {
        if (animationInstance) {
          animationInstance.destroy();
        }
      };
    } else {
      const animationInstanceMobile = lottie.loadAnimation({
        container: lottieRefMobile.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animationDataMobile,
      });

      return () => {
        if (animationInstanceMobile) {
          animationInstanceMobile.destroy();
        }
      };
    }
  }, [animationData, animationDataMobile]);

  return (
    <div className="loading-animation-container">
      <div ref={lottieRef} className="lottie-animation hidden lg:block" />
      <div ref={lottieRefMobile} className="lottie-animation block lg:hidden" />
    </div>
  );
};

export default LoadingAnimation;
